import { render, staticRenderFns } from "./RumusUmumGrade.vue?vue&type=template&id=74b08516&"
import script from "./RumusUmumGrade.vue?vue&type=script&lang=js&"
export * from "./RumusUmumGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports